import { render, staticRenderFns } from "./VaultsList.vue?vue&type=template&id=5e28729c&scoped=true"
import script from "./VaultsList.vue?vue&type=script&lang=js"
export * from "./VaultsList.vue?vue&type=script&lang=js"
import style0 from "./VaultsList.vue?vue&type=style&index=0&id=5e28729c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e28729c",
  null
  
)

export default component.exports